import React from "react";
import { getIcon } from "./utils";

export function itemRender(li, itemProps) {
    const itemChildren = (
        <div>
            <span className="component-icon">
                <i className={getIcon(itemProps.dataItem.componentType) + " fa-fw"}></i>
            </span>
            {itemProps.dataItem.hidden ? (
                <del> {li.props.children}</del>
            ) : (
                <span> {li.props.children}</span>
            )}
        </div>
    );
    return React.cloneElement(li, li.props, itemChildren);
}

export function valueRender(element, value) {
    const inputDisabled = false;
    if (inputDisabled) {
        return React.cloneElement(element, element.props, <del>{value && value.componentName}</del>)
    } else {
        return React.cloneElement(element, element.props, <span>{value && value.componentName}</span>)
    }
};